<template>
  <div class="poster">
     <div class="cover">
          <img src="@/assets/company.png" alt class="top-cover"/>
      </div>
      <div class="content">
          <div class="cover12"> 如果您有用工需求之外的其他如招聘、法律咨询、税优等其他需求，欢迎留下您的联系方式，之后会有客服专员联系您。同时也欢迎扫描下方二维码添加客户微信，为您提供专属服务。</div> 
          <div class="warp">
            <van-form class="wrapBox" validate-first @submit="onSubmit">
              <van-field  label="企业名称" placeholder="请填写企业名称" v-model="compname" required :rules="[{ required: true, message: '请填写企业名称' }]"/>
              <van-field  label="联系人" placeholder="请填写联系人" v-model="contacter" required :rules="[{ required: true, message: '请填写联系人' }]" />
              <van-field  type="tel" label="联系电话" placeholder="请填写联系电话" required v-model="phonenum" :rules="[{ required: true, message: '请填写联系电话' }]" />
              <div v-show="errorMess" class="errorMessage">{{txt}}</div>
              <van-row class="buttonWarp"> 
                <van-button round block type="info" native-type="submit">
                  提交
                </van-button>
              </van-row>
            </van-form>
        </div>
        <!-- 二维码 -->
      <div class="orCode">
        <h4 style="color:#fff;font-size:15px;line-height:15px;height:15px;">联系客服，提供专属服务</h4>
        <p style="color: rgb(255, 255, 255);font-size:13px;line-height:13px;height:13px;margin:12px 0;opacity:0.5;font-weight:bold;">长按识别二维码</p>
        <div class="code">
          <img src="@/assets/orcode.png" alt/>
        </div>
        <div class="logo">
          <img src="@/assets/group.png" alt/>
        </div>
      </div>
      </div>
	</div>

</template>

<script>
import { employ } from "../api/test"
export default {

  data() {
    return {
      errorMess:false,
     compname:"" , // 企业名称
      jobneed:"",//需求岗位
      needcount:"",//需求人数
      workaddress:"",
      contacter:"",
      phonenum:"",

     workername:"", // 姓名
     gender:"", //性别
     job:"", //职业
     needsalary:"",
     histroywork:"",
     idcard:"",





      isShowSubscripButton: true,
      active: 0,
      count: 0,
      shareShow: false,
      thirdChannelLogo:'',
      showReport:false,
      custName :"",
      post :"",
      toatl :"",
      adress:"", 
      person:"",
     phone:"",
       custName1 :"",
      post1 :"",
      toatl1 :"",
      adress1:"", 
      person1:"",
     phone1:"",
     txt:''

    };
  },
  created(){

  },

  methods: {
    // 企业
    onSubmit(){
       var params = {
              compname:this.compname, // 企业名称
              // jobneed: this.jobneed,//需求岗位
              // needcount: this.needcount,//需求人数
              // workaddress: this.workaddress,
              contacter:this.contacter,//联系人
              phonenum: this.phonenum,// 联系电话
              itemcode:"",
              itemext1:"",
              address:"",
            }; 

            employ('/iWantOther',params,{
        // headers: {
        //    'content-type': 'application/form;charset=utf-8',
        // }
          }).then(function(res){
            console.log(res)
          if(res.msg == "请求成功") {
                this.$router.push({ path: '/UploadResult' })
            }else {
              this.errorMess = true;
              this.txt=res.msg
            }
          }.bind(this)).catch(function(error){
            console.log(error)
          });  
    },
  }
}
</script>

<style scoped lang='less'>
.van-cell-group van-hairline--top-bottom {
 padding:1rem 0 0 0;
}
.van-tabs {
   padding:0 10px;
}
.van-tabs__line {
  background-color:#33A1FF!important;
}
.content {
   box-sizing: border-box;
}
.warp{
    margin: 20px 15px 0px 14px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    border-radius:9px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
}
.wrapBox {
  padding-top: 20px;
}
.buttonWarp {
  width:90%;
  // height:46px;
  background:rgba(51,133,255,1);
  border-radius:10px;
  margin:1rem auto;
  // text-align: center;
  // margin-bottom: 116px;
  margin-bottom:10px;
  padding:0 .2rem;
}
//.cover1{
//     background: #fff;
//     margin: 0px 25px 10px 10px;
// }
.coverBg{
  width: 330px;
  height: 255px;

  margin-left: 25px;
}
.cover12{
    width: 300px;
    background-image: url(../assets/bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0px 15px 19.5px 14px;
    padding: 22.5px 23.5px;
    color: #5B6A77;
    line-height: 21.5px;
    font-size: 14px;
    border-radius:9px;
}
.orCode {
  margin-top:45px;
  margin-bottom:60px;
  text-align:center;
}
.orCode .logo {
  width:89px;
  height:23px;
  margin:0 auto;
}
.orCode .logo img {
   width:100%;
   height:100%;
}
.orCode .code {
  width:102px;
  height:102px;
  margin:12px auto 10px auto;
}
.orCode .code img {
   width:100%;
   height:100%;
}
 .poster {
   //background:linear-gradient(90deg,rgba(20,50,166,1),rgba(13,39,150,1));
    display:flex;
    flex-direction: column;
    width: 100%;
    height: auto;
	// padding-bottom: 30px;
	background:linear-gradient(90deg,rgba(20,50,166,1),rgba(13,39,150,1));
    .cover{
      width: 100%;
    .top-cover {
      width: 100%;
      max-height: 100%;
      vertical-align: bottom;
      overflow: hidden;
    }
    }
 }
.errorMessage{
  width:100%;height:30px;color:red;
  font-size: 14px;
  text-align: center;
  margin-bottom: -30px;
}
</style>
